/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureWirelessProduct.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	       : Oct 30, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By             : H422337
 * On             : Sep 07,2020
 * Description    : ASDS-2570 UI enhancements as part of phase-2
 *
 * By             : H422336
 * On             : Sep 14,2020
 * Description    : ASDS-2983 UI enhancements phase II bugfixes
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3552 - UI Enhancements for Phase - II -Migrate to Forge API
 *
 *  By            : H422336
 * On            : Nov 7 2020
 * Description   : ASDS-3832 UI Enhancements for Phase-II
 *
 ******************************************************************************/

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import { Modal, Button, Stepper,Grid, Notification } from '@scuf/common';

import './ConfigureWirelessProduct.css';
import 'modules/checkout/ConfigureProduct/ConfigureProduct.css';
import '@scuf/common/honeywell/theme.css';
import AddAircraftDetails from './AddAircraftDetails';
import ConfirmWirelessProductConfiguration from './ConfirmWirelessProductConfiguration';
import ConfigureWirelessActions from 'modules/checkout/redux/actions/configure-wireless-actions';
import routeConstants from 'modules/checkout/constants/route-constants';
import CheckoutConstants, { CheckoutUILabels } from 'modules/checkout/constants/checkout-constants';
import { InLineLoader } from '../../Loader/Loader';
import { ContactUsMessage } from '../../Common/ContactUsMessage';
interface IConfigureWirelessProductState {
  open: boolean;
}

interface IConfigureWirelessProductProps {
  open: boolean;
  onCancel?: any;
  wirelessProductName: string;
  wirelessProductId: string;
  gotoPrevTabWireless: any;
  gotoNextTabWireless: any;
  activeTab: number;
  enableNextBtn: boolean;
  wirelessProductPrice?: number;
  redirectTo: string;
  addProductToCartInProgress: boolean;
  isAddToCartSuccess: boolean;
  showAlertMsg: boolean;
  lastProdAddedToCart: string;
}

// Function to return lable for primary button on configuration Modal
function PrimaryButtonLabel(props: any) {
  if (props.activeTab === 2) {
    if (props.location.pathname === routeConstants.PURCHASE_SOFTWARE) {
      return CheckoutUILabels.CONFIGURATION_CONFIRM;
    }
    else {
      return CheckoutUILabels.CONFIGURATION_SAVE_BTN;
    }
  }
  else {
    return CheckoutUILabels.CONFIGURATION_NEXT;
  }
}

function ConfigContent(props: any) {
  let cardContent;
  if (props.activeTab === 1) {
    cardContent = (
      <AddAircraftDetails
        wirelessProductId={props.wirelessProductId}
      />
    );
  } else {
    cardContent = (
      <ConfirmWirelessProductConfiguration
        wirelessProductPrice={props.wirelessProductPrice}
      />
    );
  }
  return cardContent;
}

class ConfigureWirelessProduct extends React.Component<IConfigureWirelessProductProps & RouteComponentProps, IConfigureWirelessProductState> {

  constructor(props: IConfigureWirelessProductProps & RouteComponentProps) {
    super(props);
    this.state = {
      open: true
    };
  }

  render() {

    if (this.props.redirectTo) {  // based on this filed will be redirected to my cart page.
      return (
        <Redirect to={this.props.redirectTo} />
      );
    }
    return (
      // code to open modal
      <React.Fragment>
        {this.renderModal()}
      </React.Fragment>
  );

  }
  renderModal() {
    const productName = this.props.wirelessProductName;
    let productClass = CheckoutConstants.DLMUW_PRODUCT_CLASSNAME;
    let productClassIcon = 'cwa-modal-product-icon';
    if(productName.toLowerCase().includes(CheckoutConstants.DLMUW_PRODUCT_NAME)){
      productClass = CheckoutConstants.DLMUW_PRODUCT_CLASSNAME;
      productClassIcon = 'cwa-modal-product-icon-dmlu';
    }else if(productName.toLowerCase().includes(CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME)){
      productClass = CheckoutConstants.ANALYZER_PRODUCT_CLASSNAME;
    } else if (productName.toLowerCase().includes(CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME)) {
      productClass = CheckoutConstants.FAULT_PRODUCT_CLASSNAME;
    } else if (productName.toLowerCase().includes(CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME)) {
      productClass = CheckoutConstants.REMOTE_TERMINAL_PRODUCT_CLASSNAME;
    }
    return (
      <Modal
        closeIcon={true}
        onClose={() => this.props.onCancel(this.props.location.pathname)}
        size="large"
        open={this.state.open}
        className="configure-wireless-modal"
        closeOnDimmerClick={false}
        closeOnDocumentClick={false}
      >
        <Modal.Header>
          <div className="cwp-modal-heading-text">
            Product Configuration
          </div>
          <div className="cwp-modal-product-line">
          <div className={productClassIcon}>
            <i className={productClass} />
            </div>
            <span className="cwp-product-name-heading">{productName}</span>
          </div>

        </Modal.Header>

        <div className="box">
          {' '}
          <Modal.Content>
          {this.props.showAlertMsg && !this.props.isAddToCartSuccess &&
                            <div>
                                <Notification
                                    hasIcon={true}
                                    title={'Unable to add ' + this.props.lastProdAddedToCart + ' in your cart.'}
                                    severity="critical"
                                >
                                    <ContactUsMessage>Please try again by clicking on Confirm button. {CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                                </Notification>
                            </div>
                        }
            <div className="cwp-modal-content">
              <div className="cwp-modal-content-area">
                <Stepper ordered={true} className="stepperClass cwp-stepper">
                  <Stepper.Item
                    title=" Add Aircraft Details"
                    icon="ac-profile"
                    iconRoot="aero"
                    active={this.props.activeTab === 1}
                    completed={this.props.activeTab > 1}
                  />
                  <Stepper.Item
                    title=" Confirm Configuration"
                    iconRoot="common"
                    icon="document-confirm"
                    active={this.props.activeTab === 2}
                    completed={this.props.activeTab > 2}
                  />
                </Stepper>
                {this.props.addProductToCartInProgress ?
                             <Grid>
                                <Grid.Row>
                                    <Grid.Column width={12} className="add-to-cart-loader">
                                        <InLineLoader text="Adding to Cart" loading={true} overlayColor="transparent">
                                        </InLineLoader>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>:
                <ConfigContent
                  activeTab={this.props.activeTab}
                  wirelessProductId={this.props.wirelessProductId}
                  wirelessProductPrice={this.props.wirelessProductPrice}
                />
                }
              </div>
            </div>
          </Modal.Content>
        </div>
        <Modal.Footer>
          <div>
            {/* if the user is in first step, then show cancel button, else show back button */}
            {this.props.activeTab === 1 ?
              <Button
                type="secondary"
                content="cancel"
                className="co-secondary-button"
                onClick={() => this.props.onCancel(this.props.location.pathname)}
              />
              :
              <Button
                type="secondary"
                content="Back"
                onClick={this.props.gotoPrevTabWireless}
                className="co-secondary-button"
              />
            }
            <Button
              type="primary"
              size="medium"
              content={PrimaryButtonLabel(this.props)}
              onClick={this.props.gotoNextTabWireless}
              // disabled={!this.props.enableNextBtn}
              className="co-primary-button"
            />
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

}

const mapDispatchToProps = {
  gotoNextTabWireless: ConfigureWirelessActions.gotoNextTabWireless,
  gotoPrevTabWireless: ConfigureWirelessActions.gotoPrevTabWireless,
  onCancel: ConfigureWirelessActions.onCancel,
};
function mapStateToProps(state) {
  return {
    activeTab: state.configWirelessProductData.payload.activeTab,
    enableNextBtn: state.configWirelessProductData.payload.enableNextBtn,
    redirectTo: state.configWirelessProductData.payload.redirectTo,
    lastProdAddedToCart: state.productAlertData.payload.lastProdAddedToCart,
    addProductToCartInProgress: state.productAlertData.payload.addProductToCartInProgress,
    isAddToCartSuccess: state.productAlertData.payload.isAddToCartSuccess,
    showAlertMsg: state.productAlertData.payload.showAlertMsg,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfigureWirelessProduct));